var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.showContent))]),(_vm.isMore)?_c('el-button',{staticClass:"m-l-8 p-t-0 p-b-0",attrs:{"type":"text"},on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.isExpand ? '收起' : '查看更多'))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }